import { render, staticRenderFns } from "./CarBrandIcon.vue?vue&type=template&id=2affb0f0"
import script from "./CarBrandIcon.vue?vue&type=script&lang=js"
export * from "./CarBrandIcon.vue?vue&type=script&lang=js"
import style0 from "./CarBrandIcon.vue?vue&type=style&index=0&id=2affb0f0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports